import { RE2JS } from 're2js';
import type React from 'react';

export interface FieldValidation {
  validateInput: (value: string) => boolean;
  errorMessage: (value: string) => React.ReactNode;
}

export interface FieldConfig {
  validation: FieldValidation;
  placeholder: string;
}

export function createRegexValidation(options?: {
  jsRegex?: boolean;
}): FieldValidation {
  const useJs = options?.jsRegex ?? false;

  const compile = (value: string) => {
    if (useJs) {
      new RegExp(value);
    } else {
      RE2JS.compile(value);
    }
  };

  return {
    validateInput: (value: string) => {
      try {
        compile(value);
        return true;
      } catch {
        return false;
      }
    },
    errorMessage: (value: string) => {
      try {
        compile(value);
        return '';
      } catch (e) {
        return e instanceof Error ? e.message : 'Invalid regex';
      }
    },
  };
}

export const validateRegex: FieldValidation = createRegexValidation();
